<template>
  <div class="mb-3 timeline-block">
    <span class="timeline-step">
      <i v-if="icon.startsWith('bi ')" :class="icon"></i>
      <i v-else-if="icon === 'check-bold'" class="bi bi-check-lg text-success"></i>
      <i v-else class="ni" :class="`ni-${icon} text-${icon_color || color}`"></i>
    </span>
    <div class="timeline-content" :style="!done ? 'opacity: 0.55' : null">
      <h6 class="mb-0 timeline-item-title fw-bold">
        {{ title }}
      </h6>
      <p class="mt-1 mb-0 timeline-item-date">
        <i class="bi bi-clock me-1 opacity-75"></i>{{ dateTime }}
      </p>
      <p v-if="description" class="mt-2 mb-2 timeline-item-desc">
        {{ description }}
      </p>
      <div v-if="badges && badges.length" class="mt-1">
        <span
          v-for="(badge, index) of badges"
          :key="index"
          class="badge badge-sm me-1 rounded-pill"
          :class="badge === 'Gecikmiş' ? 'bg-danger-subtle text-danger' : 'bg-info-subtle text-info'"
        >
          {{ badge }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineItem",
  props: {
    color: {
      type: String,
      default: "",
    },
    icon_color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.timeline-item-title {
  font-size: 0.84rem;
  color: var(--app-heading, #1e293b);
}

.timeline-item-date {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--app-text, #64748b);
}

.timeline-item-desc {
  font-size: 0.78rem;
  color: var(--app-heading, #334155);
  line-height: 1.35;
}

[data-theme="dark"] {
  .timeline-item-title {
    color: #f1f5f9;
  }

  .timeline-item-date {
    color: #94a3b8;
  }

  .timeline-item-desc {
    color: #cbd5e1;
  }
}
</style>
